import { render, staticRenderFns } from "./Recorder.vue?vue&type=template&id=7f4ea810&scoped=true&lang=pug&"
import script from "./Recorder.vue?vue&type=script&lang=js&"
export * from "./Recorder.vue?vue&type=script&lang=js&"
import style0 from "./Recorder.vue?vue&type=style&index=0&id=7f4ea810&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4ea810",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f4ea810')) {
      api.createRecord('7f4ea810', component.options)
    } else {
      api.reload('7f4ea810', component.options)
    }
    module.hot.accept("./Recorder.vue?vue&type=template&id=7f4ea810&scoped=true&lang=pug&", function () {
      api.rerender('7f4ea810', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Recorder.vue"
export default component.exports